import { useEffect, useState } from 'react'
import { Blurhash } from 'react-blurhash'
import { CiImageOn } from 'react-icons/ci'

import defaultImage from '@/assets/image-default.jpg'

interface ImageInterface {
  className?: string
  hash?: string | null
  src?: string | null
  alt?: string
}

const ImageComponent = ({ className, hash, src, alt }: ImageInterface) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  useEffect(() => {
    if (src) {
      const img = new Image()
      img.src = src
      img.onload = () => setImgLoaded(true)
      img.onerror = () => setImgLoaded(true)
    }
  }, [src])

  if (!imgLoaded && src && !hash)
    return (
      <div className={className ? className : ''}>
        <CiImageOn className="animate-pulse object-cover text-gray-600" />
      </div>
    )
  if (imgLoaded && src)
    return (
      <div className={className ? className : ''}>
        <img alt="imagen" className="object-cover" src={src} />
      </div>
    )
  if (!imgLoaded && hash)
    return (
      <div className={className ? className : ''}>
        <Blurhash
          hash={hash}
          height={'100%'}
          style={{
            minWidth: '100%',
            minHeight: '100%',
            objectFit: 'scale-down',
            padding: 5,
          }}
          width={'100%'}
        />
      </div>
    )
  return (
    <img
      alt={alt ?? 'img'}
      className={`object-cover object-center ${className}`}
      loading="lazy"
      onLoad={() => setImgLoaded(true)}
      src={src ? src : defaultImage}
    />
  )
}

export default ImageComponent
